import {TimeZone} from '@hconnect/uikit'
import {timeRangeParamToDateRange} from '@hconnect/uikit/src/lib2/components/simpleDatePicker/dateRangePickerHelpers'
import {getI18n} from 'react-i18next'

import {getRcfaComplianceQuickSelectionItems} from '../utils'

export const rcfaComplianceTimeRangeMapper = (
  timezone: TimeZone,
  timeRange?: string
): {from?: string; to?: string} => {
  const selectionItems = getRcfaComplianceQuickSelectionItems(getI18n().t, timezone)
  const [from, to] = timeRangeParamToDateRange({timeRange, selectionItems})

  return {from: from?.toISOString(), to: to?.toISOString()}
}
